<template>
  <div class="brand-page" ref="gallery">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        物流公司
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div @click="getting()" style="margin-left:4px">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto" class="filtrate">
      <div class="filtrate_head">
        <div class="filtrate_filer">筛选查询</div>
        <div class="filtrate_seek">
          <strong>快递公司:</strong>
          <el-input
            size="small"
            clearable
            v-model="input"
            placeholder="请输入快递公司名称"
            style="width:194px"
          ></el-input>
          <strong>状态:</strong>
          <template>
            <el-select size="small" clearable v-model="value" placeholder="全部">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </template>

          <button class="filtrate_seek_sousuo" @click="search()" icon="el-icon-search">搜索</button>
        </div>
      </div>
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">
          <i class="fas fa-bars"></i>
          数据列表
        </div>
        <!-- <div class="create">
          <el-row>
            <el-button @click="dialogFormVisible = true" class="btn1">添加品牌</el-button>
          </el-row>
        </div>-->
      </div>

      <div class="table">
        <el-table :data="dataP" ref="multipleTable" border style="width: 100%">
          <el-table-column label="编号" prop="id" width="100" style="text-align:center"></el-table-column>
          <el-table-column prop="com_name" label="公司名称" width="150"></el-table-column>
          <el-table-column prop="com_info" show-overflow-tooltip label="配送描述"></el-table-column>
          <el-table-column prop="create_date" label="添加时间"></el-table-column>
          <el-table-column prop="status" label="禁用/激活">
            <template slot-scope="scope">
              <el-switch
                @change="status($event,scope.row.id)"
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#dcdfe6"
                active-value="1"
                inactive-value="0"
              ></el-switch>
            </template>
          </el-table-column>

          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <el-button
                @click="dialogFormVisible1 = true,dete(scope.row.id)"
                type="text"
                class="button1"
              >编辑</el-button>

              <el-button type="text" class="button1" @click="del(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pager" style="text-align:center ; margin:0">
        <el-row>
          <el-col>
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="15"
              @current-change="setPage"
            ></el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
    <noAccess v-else></noAccess>
    <!-- 添加物流-->
    <el-dialog title="添加物流信息" :visible.sync="dialogFormVisible" width="500px">
      <el-form :model="form">
        <el-form-item label="公司名称:">
          <el-input v-model="form.com_name" autocomplete="off" style="width:66%"></el-input>
        </el-form-item>
        <el-form-item label="配送描述:">
          <textarea name id cols="40" rows="10" v-model="form.com_info" placeholder="请输入内容"></textarea>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible = false,dete1()">确 定</el-button>
      </div>
    </el-dialog>
    <!--  编辑弹窗 -->
    <el-dialog title="编辑物流信息" :visible.sync="dialogFormVisible1" width="500px">
      <el-form>
        <el-form-item label="公司名称:">
          <el-input v-model="com_name" autocomplete="off" style="width:66%"></el-input>
        </el-form-item>
        <el-form-item label="配送描述:">
          <textarea name id cols="40" rows="10" v-model="com_info" placeholder="请输入内容"></textarea>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible1 = false , deteSubmit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
   

<script>
// import $ from "jquery";
export default {
  name: "gallery",
  data() {
    return {
      serve: this.$store.state.serve,
      role: true,
      options: [
        {
          value: "选项1",
          label: "激活",
          id: 1
        },
        {
          value: "选项2",
          label: "禁用",
          id: 0
        }
      ],
      value: "",
      dialogFormVisible1: false,
      dialogFormVisible: false,
      id: "",
      com_name: "",
      com_info: "",
      form: {
        com_name: "",
        com_info: "",
        com_name1: "",
        com_info1: "",
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      // formLabelWidth: '120px',
      dataP: [],
      input: "",
      swite: "",

      create_date: "",
      //  status : '',

      selectAll: false,
      idString: "",
      brand: [],
      page: null,
      total: null,
      pages: null,
      values: "",

      username: "",
      token: ""
    };
  },
  created() {
    this.$store.state.topActiveId = 7;
    this.$store.state.leftTitle = "物流公司";
    this.getting();
  },
  methods: {
    setPage(v) {
      this.page = v;
      this.getting(v);
      this.selectAll = false;
    },
    search() {
      //搜索
      this.dataP = [];

      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      if (this.token === this.token) {
        this.axios
          .get(this.serve + "/admin/express_list", {
            params: {
              username: this.username,
              token: this.token,
              com_name: this.input,
              status: this.value
            }
          })
          .then(res => {
            var json = res.data.data.results;
            if (res.data.status == "success") {
              for (var key in json) {
                if (key >= 0) {
                  that.dataP.push(json[key]);
                }
              }
            } else {
              if (res.data.msg == "无权访问") {
                this.role = false;
              }
              this.dataP = [];
            }
          });
      }
    },
    getting(page) {
      //获取数据
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/express_list", {
          params: {
            username: this.username,
            token: this.token,
            page
          }
        })
        .then(res => {
          that.dataP = [];

          if (res.data.status == "success") {
            var json = res.data.data.results;
            this.page = res.data.data.now_page;
            this.total = res.data.data.total;
            for (var key in json) {
              if (key >= 0) {
                that.dataP.push(json[key]);
                var time = json[key].create_date;
                var timeNew = new Date(parseInt(time) * 1000)
                  .toLocaleString()
                  .replace(/:\d{1,2}$/, " ");
                json[key].create_date = timeNew;
              }
            }
          } else {
            if (res.data.msg == "无权访问") {
              this.role = false;
            }
          }
        });
    },
    dete1() {
      //添加部门
      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/add_express", {
          params: {
            username: this.username,
            token: this.token,
            com_name: this.form.com_name,
            com_info: this.form.com_info
          }
        })
        .then(res => {
          if (res.data.status === "success") {
            this.getting();
          }
        });
    },
    dete(id) {
      //编辑部门
      var that = this;
      that.id = id;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/express_info", {
          params: {
            username: this.username,
            token: this.token,

            id: id
          }
        })
        .then(res => {
          var json = res.data.data;

          if (res.data.status === "success") {
            that.com_name = json.com_name;
            that.com_info = json.com_info;
          }
        })
        .catch(err => {
          alert("操作失败");
        });
    },
    deteSubmit() {
      //编辑确定
      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/set_express", {
          params: {
            username: this.username,
            token: this.token,
            com_name: this.com_name,
            com_info: this.com_info,
            id: this.id
          }
        })
        .then(res => {
          var json = res.data;
          if (json.status === "success") {
            this.getting();
          }else if(res.data.code == '403'){
            this.$message.error(res.data.msg); 
          } 
        })
        .catch(err => {
          alert("操作失败");
        });
    },
    status(v, id) {
      //禁用激活
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/express_status", { //https://www.bioflin.com:83
          params: {
            username: this.username,
            token: this.token,
            id: id
          }
        })

        .then(res => {
          if (res.data.status == "success") {
            if (v == 1) {
              var str = "激活";
            } else {
              var str = "禁用";
            }
            this.$notify({
              title: str + "成功",
              message: "管理员" + str + "成功",
              type: "success"
            });
          }else if(res.data.code == '403'){
            this.$message.error(res.data.msg); 
          } 
        });
    },
    del(id) {
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      var that = this;
      this.$confirm("删除后不能恢复, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/del_express", {
              params: {
                username: this.username,
                token: this.token,
                id: id
                // com_name : this.com_name,
                // com_info : this.com_info
              }
            })
            .then(function(res) {
              if (res.data.status == "success") {
                that.getting();
                that.$message({
                  type: "success",
                  message: "删除成功!"
                });
              }else if(res.data.code == '403'){
                that.$message.error(res.data.msg); 
              }  else {
                that.$message({
                  type: "error",
                  message: "删除失败!"
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>

<style lang="scss">
.button1 {
  // border: 0;
  border: none;
  outline: none;
  background: none;
  font-size: 14px;
  font-family: "MicrosoftYaHeiLight";
  font-weight: 300;
  color: rgba(51, 51, 51, 1);
  line-height: 18px;
  cursor: pointer;
}
.button1:hover {
  color: #0099ff;
}
.topBar {
  margin-bottom: 40px;
  .subTitle {
    width: 1050px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
  }
  .rutun {
    width: 78px;
    height: 28px;
    background: #fff;
    border: 1px solid rgba(221, 221, 221, 1);
    text-align: center;
    margin-top: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }
  .rutun:hover {
    color: #0099ff;
  }
}
// .form-title{
//   // justify-content: space-between;
//   // align-items: center
// }
.filtrate {
  width: 1060px;
  height: 100%;
  margin-left: 420px;
  // background: orange;

  .filtrate_head {
    height: 130px;
    width: 100%;
    margin-bottom: 30px;
    // background: pink;
    .filtrate_filer {
      height: 46px;
      width: 1040px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 16px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 46px;
      padding-left: 14px;
    }
    .filtrate_seek {
      position: relative;
      font-size: 16px;
      // border-bottom: 1px solid rgba(221, 221, 221, 1);
      border-left: 1px solid rgba(221, 221, 221, 1);
      border-right: 1px solid rgba(221, 221, 221, 1);
      border-bottom: 1px solid rgba(221, 221, 221, 1);
      height: 86px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(51, 51, 51, 1);
      // margin: 24px 0 0 17px;
      display: flex;
      align-items: center;
      background: #fff;
      > strong {
        font-size: 16px;
        font-family: "MicrosoftYaHei";
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-left: 24px;
        margin-right: 6px;
      }
      .filtrate_seek_sousuo {
        text-align: center;
        line-height: 28px;
        font-size: 14px;
        font-family: "MicrosoftYaHeiLight";
        font-weight: 300;
        color: rgba(102, 102, 102, 1);
        width: 74px;
        height: 28px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        position: absolute;
        right: 18px;
        top: 29px;
        cursor: pointer;
      }
      .filtrate_seek_sousuo:hover {
        color: #0099ff;
      }
    }
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }

    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }
}
.brand-page {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 50px;
  .claify {
    width: 4px;
    height: 16px;
    background: rgba(52, 152, 219, 1);
    position: absolute;
    top: 17px;
    left: -10px;
  }
  .create {
    float: right;
    margin-right: 20px;
    // margin-top: 7px;
    padding-top: 7px;
  }
  .cover {
    width: 50px;
    display: block;
    margin: 0 auto;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    position: relative;
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
  }
  .el-table th > .cell {
    text-align: center;
  }
  .cell {
    text-align: center;
  }
}
</style>

